export const APPLIANCE_PACKAGE_PRIORITIES = ['Refrigerators', 'Microwaves', 'Ranges', 'Dishwashers'];
export const MCC_FULFILLMENT_METHOD_DIRECT_DELIVERY = 'DirectDelivery';
export const KITCHEN_PACKAGE = 'kitchen package';
export const GM_PACKAGE = 'gm';